export default "__VITE_ASSET__95bd79c1__"